import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_APP016_Request,
  IAPI_APP016_Response,
  IAPI_STA010_Request,
  IAPI_STA010_Response,
  IAPI_STA013_Request,
  IAPI_STA013_Response,
} from "../../../type/apiType";

// 掛金確定後職員情報参照
// API仕様書_法人職員
const httpAPI_STA010 = async (
  param: IAPI_STA010_Request
): Promise<IAPI_STA010_Response> => {
  let res = await http.post(ApiUrl.API_STA010, {
    ...param,
  });

  return res.data;
};

// 掛金確定後職員情報更新
// API仕様書_法人職員
const httpAPI_STA013 = async (
  param: IAPI_STA013_Request
): Promise<IAPI_STA013_Response> => {
  let res = await http.post(ApiUrl.API_STA013, {
    ...param,
  });

  return res.data;
};

// 申請状況更新API
// API仕様書_申請情報_申請状況更新
const httpAPI_APP016 = async (
  param: IAPI_APP016_Request
): Promise<IAPI_APP016_Response> => {
  let res = await http.post(ApiUrl.API_APP016, {
    ...param,
  });

  return res.data;
};

export { httpAPI_STA010, httpAPI_STA013, httpAPI_APP016 };
